import React from "react";
import { Route } from "react-router";
import AddOnLandingPage from "pages/OrderPages/AddOnLandingPage/AddOnLandingPage";
import BuildOrderPage from "pages/OrderPages/BuildOrderPage/BuildOrderPage";
import ViewPriceEstimatesPage from "pages/OrderPages/ViewPriceEstimatesPage/ViewPriceEstimatesPage";
import NewOrderShippingDetailsPage from "pages/OrderPages/NewOrderShippingDetailsPage/NewOrderShippingDetailsPage";
import NewOrderFormProvider from "pages/OrderPages/NewOrderShippingDetailsPage/contexts/Form/NewOrderFormProvider";
import ReviewOrderPage from "pages/OrderPages/ReviewOrderPage/ReviewOrderPage";
import NewOrderConfirmationPage from "pages/OrderPages/NewOrderConfirmation/NewOrderConfirmation";

export const AddOnsRoutes = (
	<Route path="add-ons">
		<Route
			path=":orderId"
			element={<AddOnLandingPage />}
		/>
		<Route
			path="build-order/:orderId/:draftId?"
			element={<BuildOrderPage isAddOn />}
		/>
		<Route
			path="view-price-estimates/:orderId"
			element={<ViewPriceEstimatesPage isAddOn />}
		/>
		<Route
			path="shipping-details/:orderId"
			element={
				<NewOrderFormProvider>
					<NewOrderShippingDetailsPage isAddOn />
				</NewOrderFormProvider>
			}
		/>
		<Route
			path="review-order/:orderId"
			element={<ReviewOrderPage isAddOn />}
		/>
		<Route
			path="confirmation/:orderId"
			element={<NewOrderConfirmationPage isAddOn />}
		/>
	</Route>
);
